<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-4">
    <h2>Projetos</h2>
  </div>
  <div class="col-lg-8 d-flex justify-content-end d-wrap">
    <div class="new-button">
      <button class="btn btn-primary imprimir-agenda" type="btn" (click)="openPrintModal()">
        <img src="assets/images/svgs/print.svg" alt="Imprimir">
      </button>
    </div>
    <div class="new-project" *ngIf="filters?.canCreatInd">
      <a class="btn btn-primary" [routerLink]="['/pre-projeto/projeto/adicionar']">Novo Projeto</a>
    </div>
  </div>
</div>

<div class="open-filters" *ngIf="!filterActive">
  <button class="btn-filters-close" type="button" (click)="filterActive = true">
    <img src="assets/images/svgs/Filtros.svg">
  </button>
</div>

<div *ngIf="filterActive" class="wrapper wrapper-content animated fadeInRight" [@slideIn]="filterActive">
  <div class="row">
    <div class="col-12">
      <div class=" float-e-margins">
        <div class="form_search">
          <div class="m-b">
            <div class="form-group form-filter">
              <h3>Filtros</h3>
              <div class="col-8 d-flex justify-content-end">
                <button class="btn-filters" type="button" (click)="cleanSearch()">
                  <img src="assets/images/svgs/Limpar_filtros.svg">
                  <span>Limpar Filtros</span>
                </button>
                <button class="btn-filters-close" type="button" (click)="closeFilter()">
                  <img src="assets/images/svgs/Fechar.svg" alt="Pesquisar">
                </button>
              </div>
            </div>
          </div>
          <form [formGroup]="form">
            <div class="form-group row">
              <div class="m-b col-sm-5">
                <label class="col-sm-12 pb-1">Status do projeto</label>
                <ng-select id="filter_process_sub_stat_id" class="ng-select-alternative" [items]="filters?.listProcessSubStat" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_process_sub_stat_id">
                </ng-select>
              </div>
              <div class="m-b col-sm-5">
                <label class="col-sm-12 pb-1">Órgão</label>
                <ng-select id="filter_agency" class="ng-select-alternative" [items]="filters?.agencyList" [multiple]="true" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Todos" formControlName="filter_agency">
                </ng-select>
              </div>
            </div>

            <div class="form-group row">
              <div class="m-b col-sm-5">
                <label class="col-sm-12 pb-1">Posição</label>
                <ng-select id="filter_process_control_id" class="ng-select-alternative" [items]="filters?.listProcessControl" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_process_control_id">
                </ng-select>
              </div>

              <div class="m-b col-sm-5">
                <label class="col-sm-12 pb-1">Fonte recurso</label>
                <ng-select id="filter_resource_id" class="ng-select-alternative" [items]="filters?.resourceList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_resource_id">
                </ng-select>
              </div>
            </div>

            <div class="form-group row">
              <div class="m-b col-sm-5">
                <label class="col-sm-12 pb-1">RF beneficiada</label>
                <ng-select id="filter_rf_ben" class="ng-select-alternative" [items]="filters?.RFList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_rf_ben">
                </ng-select>
              </div>

              <div class="m-b col-sm-5">
                <label class="col-sm-12 pb-1">Corede beneficiado</label>
                <ng-select id="filter_corede_ben" class="ng-select-alternative" [items]="filters?.coredeList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_corede_ben">
                </ng-select>
              </div>
            </div>

            <div class="form-group row">
              <div class="m-b col-sm-5">
                <label class="col-sm-12 pb-1">Município Beneficiado</label>
                <ng-select id="filter_city_ben" class="ng-select-alternative" [items]="filters?.cityList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_city_ben">
                </ng-select>
              </div>

              <div class="m-b col-sm-5">
                <label class="col-sm-12 pb-1">Projeto Selecionado</label>
                <ng-select id="filter_project_selected" class="ng-select-alternative" [items]="filters?.listPPSelected" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="filter_project_selected">
                </ng-select>
              </div>
            </div>

            <div class="form-group row">
              <div class="m-b col-sm-5">
                <label class="col-sm-12 pb-1">Custo Total</label>
                <ng-select id="filter_cost_total" class="ng-select-alternative" [items]="filters?.listComp" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="filter_cost_total">
                </ng-select>
              </div>

              <div class="m-b m-t-s col-sm-2" *ngIf="form.get('filter_cost_total').value">
                <input id="filter_cost_total1" class="form-control text-right" formControlName="filter_cost_total1" (keyup)="formatarMedidaFisica('filter_cost_total1')">
              </div>

              <div class="m-b m-t-s col-sm-2" *ngIf="form.get('filter_cost_total').value == 4">
                <input id="filter_cost_total2" class="form-control text-right" formControlName="filter_cost_total2" (keyup)="formatarMedidaFisica('filter_cost_total2')">
              </div>
            </div>

            <div class="form-group row">
              <div class="m-b col-sm-5">
                <label class="col-sm-12 pb-1">Valor da Contrapartida</label>
                <ng-select id="filter_cost_without_loan" class="ng-select-alternative" [items]="filters?.listComp" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="filter_cost_without_loan">
                </ng-select>
              </div>

              <div class="m-b m-t-s col-sm-2" *ngIf="form.get('filter_cost_without_loan').value">
                <input id="filter_cost_without_loan1" class="form-control text-right" formControlName="filter_cost_without_loan1" (keyup)="formatarMedidaFisica('filter_cost_without_loan1')">
              </div>

              <div class="m-b m-t-s col-sm-2" *ngIf="form.get('filter_cost_without_loan').value == 4">
                <input id="filter_cost_without_loan2" class="form-control text-right" formControlName="filter_cost_without_loan2" (keyup)="formatarMedidaFisica('filter_cost_without_loan2')">
              </div>
            </div>

            <div class="form-group row">
              <div class="m-b col-sm-5">
                <label class="col-sm-12 pb-1">Processo</label>
                <ng-select id="filter_process_id" class="ng-select-alternative" [items]="filters?.listProcess" bindLabel="title" bindValue="id" placeholder="Selecione" formControlName="filter_process_id" (change)="changeProcess()">
                </ng-select>
              </div>

              <div class="m-b col-sm-5">
                <label class="col-sm-12 pb-1">Status do processo</label>
                <ng-select id="filter_process_stat_id" class="ng-select-alternative" [multiple]="true" [items]="filters?.listProcessStat" bindLabel="name" bindValue="id" placeholder="Selecione" formControlName="filter_process_stat_id">
                </ng-select>
              </div>
            </div>

            <div *ngIf="processFilters?.length">
              <h3 class="m-t-s">Filtros específicos do processo</h3>
              <div formArrayName="filter_question">
                <div *ngFor="let item of processFilters; let i = index" [formGroupName]="0">

                  <div class="form-group row" *ngIf="item?.type_id == filters?.ppQuestion['TYPE_TEXTO']">
                    <div class="m-b col-sm-5">
                      <label class="col-sm-12 pb-1">{{ item?.report_or_title }}</label>
                      <input class="form-control" [formControlName]="item?.id">
                    </div>
                  </div>

                  <div class="form-group row" *ngIf="item?.type_id == filters?.ppQuestion['TYPE_NUMERICO']" [formGroupName]="item?.id">
                    <div class="m-b col-sm-5">
                      <label class="col-sm-12 pb-1">{{ item?.report_or_title }}</label>
                      <ng-select id="filter_cost_total" class="ng-select-alternative" [items]="filters?.listComp" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="vl0">
                      </ng-select>
                    </div>

                    <div class="m-b m-t-s col-sm-2" *ngIf="getControl(item?.id, 'vl0')?.value">
                      <input id="filter_cost_total1" class="form-control text-right" formControlName="vl1" (keyup)="formatarMedidaFisica2(item?.id, 'vl1', item?.dec_places !== null ? item?.dec_places : 4)">
                    </div>

                    <div class="m-b m-t-s col-sm-2" *ngIf="getControl(item?.id, 'vl0')?.value == 4">
                      <input id="filter_cost_total2" class="form-control text-right" formControlName="vl2" (keyup)="formatarMedidaFisica2(item?.id, 'vl2', item?.dec_places !== null ? item?.dec_places : 4)">
                    </div>
                  </div>

                  <div class="form-group row" *ngIf="item?.type_id == filters?.ppQuestion['TYPE_DATA']" [formGroupName]="item?.id">
                    <div class="m-b col-sm-5">
                      <label class="col-sm-12 pb-1">{{ item?.report_or_title }}</label>
                      <ng-select id="filter_cost_total" class="ng-select-alternative" [items]="filters?.listComp" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="vl0">
                      </ng-select>
                    </div>

                    <div class="m-b m-t-s col-sm-2" *ngIf="getControl(item?.id, 'vl0')?.value && getControl(item?.id, 'vl0')?.value != 4">
                      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="vl1" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (keyup)="clearInput($event)">
                    </div>

                    <div class="m-b m-t-s col-sm-4" *ngIf="getControl(item?.id, 'vl0')?.value == 4">
                      <input class="form-control" #daterangepicker="bsDaterangepicker" bsDaterangepicker formControlName="dataRange" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa - dd/mm/aaaa" (keyup)="clearInput($event)">
                    </div>
                  </div>

                  <div class="form-group row" *ngIf="item?.type_id == filters?.ppQuestion['TYPE_COMBO']">
                    <div class="m-b col-sm-5">
                      <label class="col-sm-12 pb-1">{{ item?.report_or_title }}</label>
                      <ng-select id="filter_corede_ben" class="ng-select-alternative" [items]="item?.questionList" [multiple]="true" bindLabel="ds_value" bindValue="ds_value" placeholder="Todos" [formControlName]="item?.id">
                      </ng-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-12 m-b">
                <div class="search-button">
                  <button type="button" (click)="search(true)">Filtrar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="system-table">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="title-width">Código</th>
          <th>Projeto</th>
          <th class="text-center">Órgão Responsável</th>
          <th class="text-center">Projeto Selecionado</th>
          <th class="text-center">Custo total estimado</th>
          <th class="text-center">Valor da Contrapartida</th>
          <th class="text-center">Valor Concedente / Financiamento</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of projetoList">
          <tr>
            <td class="title">{{ item?.id }}</td>
            <td><span class="title-span">{{item?.title}}</span></td>
            <td class="text-center">{{ item?.agency_name }}</td>
            <td class="text-center">{{ item?.project_selected }}</td>
            <td class="text-center">{{ item?.cost_total }}</td>
            <td class="text-center">{{ item?.cost_without_loan }}</td>
            <td class="text-center">{{ item?.cost_loan }}</td>
            <td>
              <div class="btn-icon btn-icon-auto">
                <a [routerLink]="['/pre-projeto/projeto/', item.id]" class="icon-table">
                  <img src="assets/images/svgs/lupa.svg" tooltip="Visualizar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="projetoList?.length && total">
          <th class="title-width" colspan="4">Totais de projetos: {{total?.total}}</th>
          <th class="text-center">{{total?.ppCostTotal}}</th>
          <th class="text-center">{{total?.ppCostWithoutLoan}}</th>
          <th class="text-center">{{total?.ppCostLoan}}</th>
          <th></th>
        </tr>

        <tr *ngIf="!projetoList?.length" class="border-b-radius">
          <td colspan="7" class="text-center">Nenhum Projeto Encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #modalPrint>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Impressão de Relatório</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closePrintModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Tipo de Relatório</label>
        <ng-select id="report_type" class="ng-select-alternative" [items]="reportList" [(ngModel)]="report_type" bindLabel="label" bindValue="id" [clearable]="false">
        </ng-select>
      </div>
    </div>

    <div class="form-group row" *ngIf="report_type == 1 || report_type == 3">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Questão</label>
        <ng-select id="report_type_1" class="ng-select-alternative" [items]="filters?.listQuestion" [(ngModel)]="report_type_1" bindLabel="report_or_title" bindValue="id" placeholder="Selecione">
        </ng-select>
      </div>
    </div>

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closePrintModal()">Fechar</button>
        <button class="btn btn-primary" type="button" (click)="imprimir()">Imprimir</button>
      </div>
    </div>
  </div>
</ng-template>

<app-loading [loader]="isLoading"></app-loading>